import drageImage from '../images/drage.jpg';
import surfImage from '../images/surf.jpg';
import fekteImage from '../images/fekting.jpg';

export default {
    "drage": {
        "title": "Dragekurs",
        "description": "Med 22 års erfaring innen dragekunsten, vil du få en rutinert instruktør.",
        "image": drageImage,
        "signup": "https://docs.google.com/forms/d/e/1FAIpQLScNVPg4yrCKVphSffQP1w0k3x6SvQzROFYIy_eJfeUZr_YDIw/viewform?usp=sf_link"
    },
    "surf": {
        "title": "Surfekurs",
        "description": "Er du klar for å surfe??? Snart lanserer jeg surfekurs!",
        "image": surfImage,
        "signup": null
    },
    "fekte": {
        "title": "Fektekurs",
        "description": "Har du set Kaptein Sabeltann, og blitt inspirert til å lære deg å fekte? Frykte ikke landkrabbe, snart kommer det et nytt kurs!",
        "image": fekteImage,
        "signup": null
    }
}
